import React from "react";

export default function Footer() {
	const appVersion = process.env.REACT_APP_VERSION;
	return (
		<footer className="footer p-3 mt-auto text-center mt-5">
			<div className="mt-3 small"> «Armavir Development center» app version - {appVersion}</div>
			<div className="mt-3 small">
				Copyright &copy; 2023 - {new Date().getFullYear()}
				<a target="blank" href="https://arpinet.am" className="text-muted">
					{" "}
					Arpinet LLC
				</a>
				, All rights reserved.
			</div>
		</footer>
	);
}
